import { useEffect, useState } from "react";
import { Moon, Sun } from "lucide-react";
import { Button } from "@/client/components/base/button";

export default function ThemeToggle() {
    const [dark, setDark] = useState<boolean>(() =>
        document.documentElement.classList.contains("dark")
    );

    useEffect(() => {
        document.documentElement.classList.toggle("dark", dark);
        localStorage.setItem("theme", dark ? "dark" : "light");
    }, [dark]);

    return (
        <Button
            variant="outline"
            size="icon"
            onClick={() => setDark((prev) => !prev)}
            title={dark ? "Switch to light mode" : "Switch to dark mode"}
        >
            {dark ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
        </Button>
    );
}